import { Component } from '@angular/core';
import { DsLinkModule } from '@bmw-ds/components';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DsIconModule } from '@bmw-ds/components';
import { DsTagModule } from '@bmw-ds/components';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-stop-sale-cell-renderer',
  imports: [DsLinkModule, DsIconModule, DsTagModule, CommonModule],
  template: `
    <div *ngIf="value === 'y' || value === 'Y'">
      <img src="/assets/images/stop_bkp.png" class="stopSale_icon" />
    </div>
  `,
  styles: [
    `
      :host {
        display: inline-block;
        .stopSale_icon {
          width: 24px;
          height: 24px;
        }
      }
    `,
  ],
})
export class StopSaleCellRenderer implements ICellRendererAngularComp {
  public value: any;
  public params!: ICellRendererParams;

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.value = params.value;
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params;
    this.value = params.value;
    return true;
  }
}
